// src/pages/PaymentSuccess.jsx

import React, { useEffect, useState } from "react";
import { useCart } from "../context/CartContext";
import { useSearchParams} from "react-router-dom";
import { LuLoaderCircle, LuCheck, LuX} from "react-icons/lu";
import { http } from "../../lib/http";
import "./paymentsuccess.css";

export default function PaymentSuccess() {
  const { clearCart } = useCart();
  const [searchParams] = useSearchParams();

  const [status, setStatus] = useState("loading");
  const [orderDetails, setOrderDetails] = useState(null);

  // Get order info from localStorage before clearing
  useEffect(() => {
    const storedOrder = localStorage.getItem("lastOrder");
    if (storedOrder) {
      try {
        setOrderDetails(JSON.parse(storedOrder));
      } catch (e) {
        console.error("Failed to parse order details", e);
      }
    }
  }, []);

  useEffect(() => {
    const verifyPayment = async () => {
      const paymentLinkId = searchParams.get("razorpay_payment_link_id");

      console.log("Payment Link ID:", paymentLinkId);

      if (!paymentLinkId) {
        setStatus("failed");
        return;
      }

      let attempts = 0;
      const maxAttempts = 5;

      while (attempts < maxAttempts) {
        try {
          const response = await http.get(
            `/web/payment-status/${paymentLinkId}`
          );

          console.log("API Raw Response:", response);

          const data = response?.data || response;

          console.log("Processed Data:", data);

          if (data?.status === "paid") {
            clearCart();
            localStorage.clear();
            setStatus("success");
            return;
          }

          if (data?.status === "failed") {
            setStatus("failed");
            return;
          }

        } catch (error) {
          console.error("Payment status check failed:", error);
        }

        // wait 2 seconds before retry
        await new Promise((resolve) => setTimeout(resolve, 2000));
        attempts++;
      }

      // If still not confirmed
      setStatus("failed");
    };

    verifyPayment();
  }, [searchParams, clearCart]);

  // =============================
  // UI Rendering
  // =============================

  if (status === "loading") {
    return (
      <div className="payment-success-page">
        <div className="payment-container">
          <div className="decorative-circle decorative-circle-1"></div>
          <div className="decorative-circle decorative-circle-2"></div>
          
          <div className="payment-card">
            <div className="icon-container loading">
              <LuLoaderCircle size={50} />
            </div>
            <h2 className="payment-title">Verifying Payment</h2>
            <p className="payment-subtitle loading-text">
              Please wait while we confirm your payment details...
            </p>
            
            <div className="order-details">
              <h3>Transaction Details</h3>
              <div className="order-row">
                <span className="order-label">Payment ID</span>
                <span className="order-value">{searchParams.get("razorpay_payment_link_id")?.slice(0, 20)}...</span>
              </div>
              <div className="order-row">
                <span className="order-label">Status</span>
                <span className="order-value" style={{ color: '#6366f1' }}>Processing...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (status === "success") {
    return (
      <div className="payment-success-page">
        <div className="payment-container">
          <div className="decorative-circle decorative-circle-1"></div>
          <div className="decorative-circle decorative-circle-2"></div>
          
          <div className="payment-card">
            <span className="status-badge success">
              <LuCheck size={16} />
              Payment Confirmed
            </span>
            
            <div className="icon-container success">
              <LuCheck size={50} />
            </div>
            
            <h2 className="payment-title">Order Confirmed! 🎉</h2>
            <p className="payment-subtitle">
              Thank you for your order. We've sent a confirmation to your WhatsApp number.
            </p>

            {orderDetails && (
              <div className="order-details">
                <h3>Order Summary</h3>
                <div className="order-row">
                  <span className="order-label">Order ID</span>
                  <span className="order-value">#{orderDetails.orderId?.slice(-8).toUpperCase() || 'N/A'}</span>
                </div>
                <div className="order-row">
                  <span className="order-label">Items</span>
                  <span className="order-value">{orderDetails.items?.length || 0} items</span>
                </div>
                <div className="order-row">
                  <span className="order-label">Total Amount</span>
                  <span className="order-value" style={{ color: '#10b981', fontWeight: '700' }}>
                    ₹{orderDetails.total?.toFixed(2) || '0.00'}
                  </span>
                </div>
              </div>
            )}

            {/* <div className="action-buttons">
              <button
                className="btn btn-primary"
                onClick={() => navigate("/")}
              >
                <LuHouse size={18} />
                Go to Home
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => navigate("/menu")}
              >
                <LuShoppingBag size={18} />
                Order More
              </button>
            </div> */}

            <div className="support-info">
              {/* <p>
              Need help? Contact us at{" "}
              <a href="tel:+919876543210">+91 98765 43210</a> or{" "}
              <a href="https://wa.me/919876543210" target="_blank" rel="noopener noreferrer">
                <LuMessageCircle size={14} style={{ verticalAlign: 'middle' }} /> WhatsApp
              </a>
            </p> */}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-success-page">
      <div className="payment-container">
        <div className="decorative-circle decorative-circle-1"></div>
        <div className="decorative-circle decorative-circle-2"></div>
        
        <div className="payment-card">
          <span className="status-badge failed">
            <LuX size={16} />
            Payment Failed
          </span>
          
          <div className="icon-container failed">
            <LuX size={50} />
          </div>
          
          <h2 className="payment-title">Payment Not Confirmed</h2>
          <p className="payment-subtitle">
            We couldn't verify your payment at this moment. Don't worry - if any amount was deducted, it will be refunded automatically within 5-7 business days.
          </p>

          <div className="support-info">
            <p>
              Still facing issues? Contact our support at{" "}
              <a href="tel:+918823006666">+91 8823006666</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

